<template lang="pug">
  span.badge.badge-dark(v-bind:style="badgeStyle") {{display}}
</template>

<script>
import Lib from '@/lib'

export default {
  props: {
    type: String,
  },
  computed: {
    badgeStyle: function() {
      const color = Lib.preset().colors.formats[this.type] || '#222222';
      return `background-color: ${color}`;
    },
    display: function() {
      return this.type == 'png' ? 'PNG'
        : this.type == 'gif' ? 'GIF'
        : this.type == 'webp' ? 'WebP'
        : !!this.type.match(/^jpe?g/) ? 'Jpeg'
        : this.type;
    }
  }
}
</script>